export default "__VITE_ASSET__DfxkuQvF__"